import React, { useEffect, useState } from "react";
import data from "../../json/Sample/Sample.json";
import { Outlet, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
const Sample1 = () => {
  const [currentHeading, setCurrentHeading] = useState("Composition");
const [dropDown,setDropdown] = useState(false)
  const { category } = useParams();

  console.log(category);
  useEffect(() => {
    setCurrentHeading(category);
  }, [category]);

  return (
    <div className="w-full flex justify-center my-[72px] md:my-20">
      <div className="w-full 2xl:container flex flex-col jusitfy-center px-6 md:p-0 md:px-10 lg:px-20 ">
        <div className="flex flex-col gap-3">
          <h1 className="text-32 md:text-48 lg:text-64 text-primarycolor w-full text-center font-semibold">{data.Title}</h1>
          {/* <p className="mtext-16 d:test-18 emd:text-18">{data.Subtitle}</p> */}
        </div>
        <div className="flex justify-center mt-8 md:mt-10 w-full ">
          <div className="w-full md:w-fit hidden md:flex rounded-full flex-wrap bg-white p-2 shadow-products justify-center">
            {data.Headings.map((item, i) => (
              <Link
                to={`/company/sample/${item}`}
                key={i}
                onClick={() => setCurrentHeading(item)}
                className={`  max-w-[210px]  flex justify-center px-3 py-[10px] lg:px-6 lg:py-3 text-14 md:text-16 rounded-[40px] font-semibold ${currentHeading
                  ? currentHeading === item
                    ? "bg-orangeyellow text-white"
                    : "text-secondaryblack"
                  : ""
                  }`}
              >
                <p className="font-semibold text-16 ">{item}</p>
              </Link>
            ))}
          </div>
          <div className={`w-full md:hidden  border border-journyborder shadow-products p-[6px] ${dropDown?"rounded-[24px]":" rounded-[64px]"}`}>
            <div className="relative  ">
              {/* Dropdown Button */}
              <div
                className="schemadropdown bg-orangeyellow border-[1px] border-commonborder rounded-[40px] px-6 py-3 w-full text-left flex justify-between items-center text-dimtext"
                onClick={() => setDropdown(prev=>!prev)}
              >
                <p className={`w-full overflow-hidden text-white text-16 font-semibold`}>
                  {currentHeading}
                </p>

                <span className="ml-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    viewBox="0 0 20 20"
                    fill="white"
                  >
                    <path
                      fillRule="evenodd"
                      d={
                        dropDown
                          ? "M14.707 10.707a1 1 0 01-1.414 0L10 7.414l-3.293 3.293a1 1 0 11-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                          : "M5.293 9.293a1 1 0 011.414 0L10 12.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      }
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
              </div>

              {/* Dropdown Menu */}
              {dropDown && (
                <div className=" z-10 bg-white w-full  max-h-[300px] overflow-auto">
                  {data.Headings.map((item, i) => (
                   item!==currentHeading &&( <Link
                      to={`/company/sample/${item}`}
                      key={i}
                      onClick={() => {
                        setCurrentHeading(item)
                        setDropdown(false)}}
                      className={` w-full flex hover:bg-orangeyellow hover:text-white  px-6 py-2 text-14 md:text-16 rounded-full font-semibold ${currentHeading
                        ? currentHeading === item
                          ? "bg-orangeyellow text-white"
                          : "text-secondaryblack"
                        : ""
                        }`}
                    >
                      <p className="font-semibold text-16 ">{item}</p>
                    </Link>)
                  ))}
                </div>
              )}
            </div>

          </div>
        </div>
        <div className="mt-16">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Sample1;
